// extracted by mini-css-extract-plugin
module.exports = {"logo":"AboutPopup_logo__HQi98","content":"AboutPopup_content__13NJR","text":"AboutPopup_text__2hPag"};